<script>
	// NPM Modules
	import dayjs from 'dayjs';
	// Partials
	import BetList from '@/Partials/Sport/Markets/_BetsList.svelte';
	// Models
	import Market from '@/Models/Market';
	// Services
	import ApiService from '@/Services/ApiService';
	import SportBetLegStore from '@/Stores/Sport/BetLegStore.js';

	export let selection;
	export let event;

	let loading = getLegsForSportscastSelection();

	function getLegsForSportscastSelection() {
		return SportBetLegStore.getLegsForSportscastSelection(selection.id);
	}

	function downloadSportSelectionBets() {
		const marketModel = new Market();
		ApiService.downloadFile(
			`${marketModel.baseUrl()}/sportcast_selections/${selection.id}/legs/export`,
			`${event.name} ${selection.name} bets - ${dayjs().format('YYYYMMDDHHmmss')}`
		);
	}
</script>

<BetList
	bind:selection_id={selection.id}
	selection_type={'sportscast_selection_id'}
	bind:loading
	export_bet_list={downloadSportSelectionBets}
/>
